import React from 'react';
import PropTypes from 'prop-types';

import { organiserFullPropTypeShape } from '../../../../proptypes';
import schemaResolver from '../../../../state/resolvers/schema/organiser';

import Meta from '../../../../containers/Meta';

/**
 * Organiser detail page meta presentational component.
 * */
const OrganiserDetailPageMeta = (props) => {
  const { canonical, description, images, title } = props;
  return (
    <Meta
      title={title}
      description={description}
      facebookImage={images && images.logo && images.logo.thumbnail}
      twitterImage={images && images.logo && images.logo.thumbnail}
      canonical={canonical}
      schemata={schemaResolver(props)}
      robots="noindex,follow"
    />
  );
};

OrganiserDetailPageMeta.propTypes = {
  /**
   * String canonical to the organiser page.
   */
  canonical: organiserFullPropTypeShape.canonical, // eslint-disable-line max-len, react/require-default-props
  /**
   * Object of images associated with the organiser.
   */
  images: organiserFullPropTypeShape.images,
  /**
   * String title of the organiser.
   */
  title: organiserFullPropTypeShape.title, // eslint-disable-line react/require-default-props
};

OrganiserDetailPageMeta.defaultProps = {
  images: undefined,
};

export default OrganiserDetailPageMeta;
